import React from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import { Redirect } from 'react-router-dom'
import { login as loginAction } from '../actions'
import { AUDIT_ACTION_LOGIN } from '../constants'
import {
  getDocumentTypes,
  getHealthInsurances,
  getHealthInsurancePlans,
  logAuditAction,
  getPatientLogin
} from '../api'
import EntryLayout from './ui/layout/entryLayout'
import LoginForm from './Forms/LogIn/index'

class LogIn extends React.Component {
  state = { isLoggedIn: false, plans: [], documentTypes: [], healthInsurances: [] }

  componentWillMount() {
    this.checkLoggedInUser()
  }

  async componentDidMount() {
    const [err, [{ data: documentTypes } = {}, { data: healthInsurances } = {}] = []] = await to(
      Promise.all([getDocumentTypes(), getHealthInsurances()])
    )
    if (!err) {
      this.setState({
        documentTypes: documentTypes.map(dt => ({ id: dt.id, name: dt.nombre })),
        healthInsurances: healthInsurances.map(hi => ({ id: hi.id, name: hi.nombre }))
      })
    }
  }

  checkLoggedInUser = () => {
    if (Object.keys(this.props.auth).length) {
      this.setState({ isLoggedIn: true })
    }
  }

  auditUserLoggedIn = () => {
    const request = {
      documento: this.props.auth.nroDocumento,
      email: this.props.auth.mail,
      idObrasocial: this.props.auth.obraSocial.id,
      accion: AUDIT_ACTION_LOGIN
    }

    logAuditAction(request)
  }

  handleSubmit = async values => {
    const request = {
      Documento: values.docNum,
      TipoDocumento: values.docType,
      ObraSocial: values.healthInsurance,
      Plan: values.healthPlan,
      Email: values.email,
      NroAfiliado: values.credential
    }
    const [err, { data } = {}] = await to(getPatientLogin(request))
    if (!err) {
      this.props.loginAction({
        ...data,
        mail: values.email,
        nroDocumento: values.docNum,
        tipoDocumento: this.state.documentTypes.find(dt => dt.id === parseInt(request.TipoDocumento)),
        obraSocial: this.state.healthInsurances.find(os => os.id === parseInt(request.ObraSocial)),
        plan: this.state.plans.find(hp => hp.id === parseInt(request.Plan))
      })
      this.auditUserLoggedIn()
      this.checkLoggedInUser()
    }
  }

  handleHealthInsuranceChange = async value => {
    const [err, { data } = {}] = await to(getHealthInsurancePlans(value))
    if (!err) {
      this.setState({ plans: data.map(p => ({ id: p.id, name: p.nombre })) })
    }
  }

  render() {
    if (this.state.isLoggedIn) {
      return <Redirect to="/inicio" />
    }

    return (
      <EntryLayout>
        <LoginForm
          docTypes={this.state.documentTypes}
          plans={this.state.plans}
          healthInsurances={this.state.healthInsurances}
          handleSubmit={this.handleSubmit}
          onHealthInsuranceChange={this.handleHealthInsuranceChange}
        />
      </EntryLayout>
    )
  }
}

const mapDispatchToProps = { loginAction }
function mapStateToProps({ auth }) {
  return { auth }
}
export default connect(mapStateToProps, mapDispatchToProps)(LogIn)
